/** @jsx jsx */
import { css, jsx, keyframes } from "@emotion/core"

import React from "react"
import { Table } from "@cd2/components"
import { useTheme } from "@cd2/theme"

import { List } from "@cd2/components"

export function LoadingTable({ recordCount = 5, columnCount = 1 }) {
  const nonData = Array(recordCount).fill("")
  const columns: React.ReactNode[] = Array(columnCount)

  for (let i = 0; i < columnCount; i++) {
    columns[i] = (
      <Table.Column key={i} heading={<Placeholder width="100px" verticalPadding={0} />}>
        {() => <Placeholder />}
      </Table.Column>
    )
  }

  return <Table data={nonData}>{columns}</Table>
}

export function LoadingRichText({ numberOfLines = 10 }) {
  const lines = Array(numberOfLines).fill("")

  return (
    <div
      css={css`
        max-width: 500px;
      `}
    >
      <List size={6}>
        {lines.map((_, i) => (
          <Placeholder key={i} width={`${Math.random() * 50 + 50}%`} />
        ))}
      </List>
    </div>
  )
}

interface IProps {
  width?: string
  height?: number
  verticalPadding?: number
  className?: string
}
export function Placeholder({
  width = "100%",
  height = 16,
  verticalPadding = 3,
  className,
}: IProps) {
  const { borderRadius } = useTheme()

  const placeHolderShimmer = keyframes`
  0% {
    background-position: top left;
  }

  100% {
    background-position: top right;
  }
`

  return (
    <div
      className={className}
      css={css`
        background: #eeeeee;
        overflow: hidden;
        height: ${height}px;
        border-radius: ${borderRadius}px;
        width: ${width};
        margin: ${verticalPadding}px 0;
        &:after {
          content: "";
          animation: ${placeHolderShimmer} 3s linear infinite;
          background: linear-gradient(to right, #eeeeee 0%, #e5e5e5 25%, #eeeeee 50%);
          background-size: 500px 100%;
          background-repeat: no-repeat;
          height: 100%;
          width: calc(100% + 1000px);
          margin-left: -500px;
          display: block;
        }
      `}
    />
  )
}
